import {wrap} from '@codeurs/front'
import React from 'react'
import {PageData} from '../../../types'
import {style} from '../../../util/style'
import {Breadcrumbs} from '../../layout/Breadcrumbs'
import {Hero, HeroType} from '../../layout/Hero'
import {Layout} from '../../layout/Layout'
import {ProductsFilter} from '../layout/product/ProductsFilter'

const styles = style('downloads')

type DownloadsType = {
	overview_title?: string
	hero: HeroType
}

export const Downloads: React.FC<PageData & DownloadsType> = wrap(Layout)(
	({title, overview_title, hero, parents, ...props}) => {
		const {downloads, product_groups: groups, product_filters: filters} = props

		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} />
				<Breadcrumbs parents={parents} title={title} />
				<ProductsFilter
					groups={groups}
					filters={filters}
					downloads={downloads}
					products={'hide'}
					downloadsOverviewTitle={overview_title || title}
				/>
			</div>
		)
	}
)
